import { AndroidSpecialService } from './android-special.service';

export * from 'domains/pages/web-special-offer/web-special-offer.reducer';
export * as selectors from 'domains/pages/web-special-offer/web-special-offer.selectors';

export const androidSpecialService = new AndroidSpecialService();

